export default __webpack_public_path__ + "static/media/Alternate_File_Icon.946caf86.svg";